module.exports = __webpack_public_path__ + "img/shade_hand.67e9b7f1.png";